import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();
  const [screenshotFailed, setScreenshotFailed] = useState(false);

  return (
    <section className="tk-hero">
      <div className="tk-hero-glow tk-hero-glow--accent" aria-hidden="true"></div>
      <div className="tk-hero-glow tk-hero-glow--violet" aria-hidden="true"></div>
      <div className="tk-hero-grid" aria-hidden="true"></div>

      <div className="tk-hero-inner">
        <div className="tk-hero-copy">
          <span className="tk-hero-badge">
            <span className="tk-hero-badge-dot" aria-hidden="true"></span>
            {t('hero.badge')}
          </span>

          <h1 className="tk-hero-title">
            Tenku - {t('hero.title')}{' '}
            <span className="tk-hero-title-highlight">{t('hero.titleHighlight')}</span>
          </h1>

          <p className="tk-hero-subtitle">{t('hero.subtitle')}</p>

          <div className="tk-hero-ctas">
            <a href="#downloads" className="tk-btn-primary">
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3 17a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2zm3.172-5.829a1 1 0 111.414-1.414L9 10.586V3a1 1 0 012 0v7.586l1.414-1.415a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4z" />
              </svg>
              <span>{t('hero.ctaPrimary')}</span>
            </a>

            <a href={t('downloads.webLink')} className="tk-btn-ghost">
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <circle cx="12" cy="12" r="9" />
                <path strokeLinecap="round" d="M3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z" />
              </svg>
              {t('hero.ctaWeb')}
            </a>
          </div>

          <p className="tk-hero-note">{t('hero.downloadSubtitle')}</p>
        </div>

        <div className="tk-hero-visual">
          <div className="tk-phone">
            <div className="tk-phone-notch" aria-hidden="true"></div>
            {screenshotFailed ? (
              <div className="tk-phone-screen tk-phone-placeholder">
                <img src="/logo.png" alt="Tenku" />
              </div>
            ) : (
              <img
                src="/img/app-hero.jpg"
                alt="Tenku app"
                className="tk-phone-screen"
                onError={() => setScreenshotFailed(true)}
              />
            )}
          </div>

          <div className="tk-float-card tk-float-card--game">
            <span className="tk-float-emoji" aria-hidden="true">⚽</span>
            <div>
              <p className="tk-float-title">{t('hero.cardGame.title')}</p>
              <p className="tk-float-meta">{t('hero.cardGame.meta')}</p>
            </div>
          </div>

          <div className="tk-float-card tk-float-card--near">
            <span className="tk-float-emoji" aria-hidden="true">📍</span>
            <div>
              <p className="tk-float-title">{t('hero.cardNear.title')}</p>
              <p className="tk-float-meta">{t('hero.cardNear.meta')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
